// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "" + {"21":"highlight","216":"lightbox","334":"leaflet"}[chunkId] + "." + {"21":"9cab926a","216":"04cca030","334":"ed3785d9"}[chunkId] + ".css";
};